<template>
  <CheckoutCard>
    <div class="flex justify-between items-center">
      <h3 class="font-medium text-lg">
        {{ $t("Payment method") }}
        <Tooltip info="Required" position="right">*</Tooltip>
      </h3>
      <div
        class="flex items-center gap-1 text-muted-foreground cursor-pointer select-none"
        @click="showMoreInformation = !showMoreInformation">
        <div class="text-xs">{{ $t(!showMoreInformation ? "More information" : "Less information") }}</div>
        <InformationCircleIcon class="size-4" />
      </div>
    </div>
    <CheckoutInfo v-if="showMoreInformation">
      <div>
        {{
          $t(
            "Choose your preferred payment method. Additional costs may be charged depending on the chosen payment method"
          )
        }}
      </div>
    </CheckoutInfo>
    <p v-if="userStore.selectedCurrency !== 'EUR'" class="text-foreground mt-3 font-bold">
      {{ $t("Note") }}: {{ $t("Payments always need to be made in Euros") }}
    </p>
    <PaymentMethods v-if="useCartStore().timeLeft" />
    <Alert v-else status="warning">{{ $t("Your reservation has expired. Please update it and try again.") }}</Alert>
  </CheckoutCard>
</template>
<script setup lang="ts">
import { PaymentMethods } from "@/components/paymentmethods";
import { useUserStore } from "@/store/user.js";
import { Alert, Tooltip } from "@xs2event/js-lib/components";
import { InformationCircleIcon } from "@heroicons/vue/24/outline";
import { CheckoutCard } from ".";
import { useCartStore } from "@/store/cart";
import { ref } from "vue";
import CheckoutInfo from "./CheckoutInfo.vue";
const userStore = useUserStore();

const showMoreInformation = ref(false);
</script>
